import React from 'react';

import { DemarcheExtraField, ExtraFieldValues } from '../../types';
import { StepText } from '../styles';
import { DynamicField } from './DynamicField';

const EMPTY_MESSAGE = 'Aucune information complémentaire requise pour cette démarche.';

/**
 * Renders a flow's `extraFields` config. This is what lets one funnel serve all nine démarches:
 * the fields are data, not JSX. Controlled — the whole values object is lifted through a single
 * `onChange`, so the caller (funnel store, Formik, a test) owns the state.
 */
type DynamicFieldsFormProps = {
  fields: DemarcheExtraField[];
  values: ExtraFieldValues;
  onChange: (values: ExtraFieldValues) => void;
  errors?: ExtraFieldValues;
  emptyMessage?: string;
};

const DynamicFieldsForm: React.FC<DynamicFieldsFormProps> = ({
  fields, values, onChange, errors = {}, emptyMessage = EMPTY_MESSAGE,
}) => {
  if (!fields.length) {
    return <StepText>{emptyMessage}</StepText>;
  }

  const handleFieldChange = (id: string, value: string): void => {
    onChange({ ...values, [id]: value });
  };

  return (
    <div>
      {fields.map((field, index) => (
        <DynamicField
          key={field.id}
          field={field}
          value={values[field.id] || ''}
          showGroupTitle={Boolean(field.group) && field.group !== fields[index - 1]?.group}
          errorMessage={errors[field.id]}
          onChange={handleFieldChange}
        />
      ))}
    </div>
  );
};

export { DynamicFieldsForm, EMPTY_MESSAGE };
